import { actions } from 'actions';

const initialState = {
  isAccount: true,       // 管理者アカウントが使用可能かのフラグ(true:使用可能、false：使用不可）
  isProgram: true,       // プログラムファイルが使用可能かのフラグ(true:使用可能、false：使用不可）
  mail: ''  // ログイン中のメールアドレス
};

/**
 * ヘッダー情報記載に必要なユーザー情報を管理する
 */
const headerReducer = (state = initialState, action ) => {
  switch (action.type) {
    case actions.SET_HEADER:
      return {
        isAccount: action.isAccount,  // 管理者アカウントが使用可能かのフラグ(true:使用可能、false：使用不可）
        isProgram: action.isProgram,  // プログラムファイルが使用可能かのフラグ(true:使用可能、false：使用不可）
        mail: action.mail             // ログイン中のメールアドレス
      };
    case actions.CLEAR_HEADER:
      return {};
    default:
      return state;
  }
};

export default headerReducer;